<template>
    <div v-if="hasRecentGlosses" class="vgtc-card mt-md-4 p-4 d-flex flex-column">
        <h2 class="recent-glosses__title pb-4 mb-5">{{ $t('search.recent_glosses') }}</h2>
        <div class="row align-items-baseline mt-n5">
            <SearchResultCard
                v-for="gloss in recentGlosses"
                class="col-12 col-md-6 col-xl-4 mt-5"
                :key="gloss.signId"
                :searchResult="gloss"
            />
            <router-link
                v-if="hasMoreRecentGlosses"
                class="link mx-auto mt-5"
                :to="{ name: 'search', query: { lb: 'Recent' } }"
            >
                {{ $t('search.load_more_recent_glosses') }}
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ISignOverview } from '../../../../functions/src/shared/contracts/api/GlossContract';
import SearchResults from './SearchResults.vue';
import { ILabel } from '../../../../functions/src/shared/contracts/api/MasterdataContract';
import SearchResultCard from './SearchResultCard.vue';

const searchModule = namespace('search');
const cacheModule = namespace('cache');

@Component({
    components: { SearchResults, SearchResultCard },
})
export default class RecentGlosses extends Vue {
    @searchModule.Getter
    recentGlosses!: ISignOverview[];

    @searchModule.Getter
    totalRecentGlossesAvailable!: number;

    @searchModule.Action
    fetchRecentGlosses!: () => Promise<void>;

    @cacheModule.Action('loadLabels')
    public loadLabels!: () => Promise<void>;

    @cacheModule.Getter('labels')
    private labels!: ILabel[];

    get hasRecentGlosses(): boolean {
        return this.recentGlosses.length > 0;
    }

    get hasMoreRecentGlosses(): boolean {
        return this.totalRecentGlossesAvailable > this.recentGlosses.length;
    }

    async mounted() {
        if (this.labels.length === 0) {
            await this.loadLabels();
        }
        this.fetchRecentGlosses();
    }
}
</script>
<style lang="scss" scoped>
.recent-glosses__title {
    font-size: $font-size-title;
    font-family: $font-family;
    font-weight: 400;
    color: $text-title-color;
    border-bottom: $divider;
}
</style>
